import { Button, Box, Heading, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, FormControl, FormLabel, Input, Stack, useDisclosure, Flex } from '@chakra-ui/react';
import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useAuth } from '../auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { server } from '../util/connect';
import Swal from 'sweetalert2';

function Login({}) {
  const navigate = useNavigate()
  const usernameRef = useRef();
  const passwordRef = useRef();
  const { user, login, logout } = useAuth();

  useEffect(()=>{
    if(user){
      const timerId = setTimeout(() => {
        navigate("/")
      }, 300);
      return () => clearTimeout(timerId);
    }
  },[user])

  const userLogin = async (loginuser, password) => {
    try {
      const loginEndpoint = '/auth/login';
  
      const userLoginData = {
        name: loginuser,
        password
      };
  
      const response = await axios.post(`${server}${loginEndpoint}`, userLoginData);
  
      const { access_token, refresh_token } = response.data;

      console.log(JSON.stringify(response.data.user))
      login(response.data.user)

      localStorage.setItem('access_token', access_token);
      localStorage.setItem('refresh_token', refresh_token);

      navigate("/")

    } catch (error) {
      Swal.fire(`Cannot login!`, "Please check your username and password!", "warning")
      console.error('Login failed:', error);
    }
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    const username = usernameRef.current.value;
    const password = passwordRef.current.value;

    //console.log('Username:', username);
    //console.log('Password:', password);

    userLogin(username, password)
  };

  return (
    <Flex
      justify="center"
      align="center"
      h="100vh"
      bg="gray.100" // Background color
    >
      <Box
        p={6}
        rounded="md"
        bg="white"
        boxShadow="md"
        w="400px" // Set the width of the form container
      >
        <Heading as="h2" size="lg" mb={6}>
          Login
        </Heading>
        <form onSubmit={handleLogin}>
          <FormControl id="username" isRequired>
            <FormLabel>Username</FormLabel>
            <Input type="text" ref={usernameRef} />
          </FormControl>
          <FormControl id="password" isRequired mt={4}>
            <FormLabel>Password</FormLabel>
            <Input type="password" ref={passwordRef} />
          </FormControl>
          <Flex justify="center" mt={6}>
            <Button
              colorScheme="blue"
              type="submit"
              w="100%" // Set button width to 100%
            >
              Login
            </Button>
          </Flex>
        </form>
      </Box>
    </Flex>
  );
}

export default Login;
